/* 
 * listings filter js component
 */

import _Abstract from "system/abstract"
export default class Component_BackButton extends _Abstract {
  constructor(el, options) 
  {
    super(el, $.extend(true,{},options), 'component')

    this.initialise();
  }

  initialise()
  {
      this.initialiseListeners();
  }

  initialiseListeners()
  {
      this.$el.click(() => this.onElementClick());
  }

  onElementClick()
  {
      if(history.length === 1 && typeof this.options.backURL !== "undefined")
      {
          //Go to the passed in url for the componenet
          window.location = this.options.backURL;
      }
      else
      {
          //go back from the history
        history.back();

      }

  }

}



/** WEBPACK FOOTER **
 ** ./components/back-button.js
 **/